import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import backend from "../../../../../../api";
import { useSelector } from "react-redux";

export default function BookingSetup({ initial = {}, saveProfile }) {
  const [form, setForm] = useState({
    ratePerSession: initial.ratePerSession || "",
    calendarLink: initial.calendarLink || "",
  });
  const [saving, setSaving] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setSaving(true);
    await saveProfile({ bookingSetup: form });
    setSaving(false);
  };

  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;


  const isStripeConnected = user?.mentorProfile?.isStripeConnected && user?.mentorProfile?.isStripeConnected ? true : false;

  async function handleConnectClick() {
    const response = await backend.get(`/pay/connect/authorize?userId=${userId}`);
    // const data = await response.json();
    console.log(response)
    if (response?.data.url) {
      window.location.href = response?.data.url; // redirect coach to stripe's connect portal
    }
  }


  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <h3>Payments</h3>

        <div className={Classes.infoConMiddle}>
          {/* <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Set Your Rate (Per Session)</h5>
              <input
                type="number"
                name="ratePerSession"
                className={Classes.inputField}
                placeholder="$100 Per Session"
                value={form.ratePerSession}
                onChange={e => setForm(p => ({ ...p, ratePerSession: e.target.value }))}
              />
            </div>
          </div> */}

          {/* <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Connect Your Calendar</h5>
              <input
                name="calendarLink"
                className={Classes.inputField}
                placeholder="https://calendly.com/you"
                value={form.calendarLink}
                onChange={e=>setForm(p=>({...p,calendarLink:e.target.value}))}
              />
            </div>
          </div> */}

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Connect Your Stripe</h5>
              <div className={Classes.flexBetween}>
                <div className={Classes.flexAlign102} onClick={() => handleConnectClick()}>
                  <img src="/assets/icons/stripe.png" alt="stripe" className={Classes.stripeImg} />
                  <div>
                    {/* <h5>Stripe</h5> */}
                    <h5 className={Classes.label}>Collect payments for your meetings</h5>
                  </div>
                </div>
                <button type="button" onClick={() => handleConnectClick()} className={Classes.connectBtn} style={{ background: isStripeConnected ? 'green' : '', color: isStripeConnected ? 'white' : '' }}><h5>{isStripeConnected ? "Connected" : "Connect"}</h5></button>
              </div>
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
